import { Component, Input, Output, OnInit, ViewChild, TemplateRef, EventEmitter } from '@angular/core';
import { DatePipe } from '@angular/common';
import { Subject } from 'rxjs';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap/modal/modal.module';
import { map, filter, reduce } from 'rxjs/operators';
import { ActivatedRoute, Router } from '@angular/router';

import { CalendarEvent, CalendarEventTimesChangedEvent, CalendarDateFormatter, CalendarMonthViewDay, CalendarEventTimesChangedEventType } from 'angular-calendar';
import { colors, division_colors } from '../colors'
import { CalendarFormatter } from '../calendar-common/calendar-formatter.provider'
import { AuthService } from '../Services/auth.service';
import { CustomerInputService } from '../Services/customer-input.service';
import { CalendarService } from '../Services/calendar.service';
import { Logininfo } from '../classes/Loginifo';
import { StringUtil } from '../classes/StringUtil';

@Component({
  selector: 'app-event-calendar',
  templateUrl: './event-calendar.component.html',
  styleUrls: ['./event-calendar.component.css'],
  providers: [
    {
      provide: CalendarDateFormatter,
      useClass: CalendarFormatter
    }
  ]
})
export class EventCalendarComponent implements OnInit {
  @ViewChild('eventAdd') eventAdd: TemplateRef<any>;
  @ViewChild('userCal') userCal: TemplateRef<any>;
  @Input()
  set ecalref(val: boolean) {
    if (val) {
      this.getCalendar(this.viewDate);
      this.ecalChange.emit(false);
    }
  }
  @Output() ecalChange = new EventEmitter<boolean>();
  modalReference: NgbModalRef;
  refresh: Subject<any> = new Subject();

  logininfo: Logininfo = this.auth.loginID;
  view: string = 'month';
  viewDate: Date = new Date();
  locale: string = 'ja';
  selectedDivision: number = 0;
  divisionName2Code: any = [];
  divisions: any;
  users: any;
  sales_users: any;
  construction_users: any;
  allEvents: any = [];
  viewEvents: any = [];
  place_list: any;
  app_place_list: any;
  eventview: any = {};
  userCalview: any = {};
  weekleyEvents: any = [];
  constructor(
    public auth: AuthService,
    public datePipe: DatePipe,
    private router: Router,
    private modal: NgbModal,
    private calendar: CalendarService,
    public customerInputService: CustomerInputService,
  ) { }

  ngOnInit() {
    this.viewEvents = [];
    //面談履歴：場所表示用
    let place_list = this.customerInputService.placeList(0);
    place_list.subscribe(place_list => {
      this.place_list = place_list;
      this.app_place_list = this.place_list.filter(place=>{
        return !place.sold;
      })
    });
    //担当者表示用
    let list = this.customerInputService.customerBase(0);
    list.subscribe(list => {
      this.divisions = list['division'];
      this.users = list['users'];
      this.sales_users = list['sales_users'];
      this.construction_users = list['construction_users'];
    });
    this.getCalendar(this.viewDate);
  }

  countUserEvent: any;
  beforeMonthViewRender({ body }: { body: CalendarMonthViewDay[] }): void {
    body.forEach(cell => {
      /*
      const groups: any = {};
      cell.events.forEach((event: CalendarEvent) => {
        let name = event.meta.division.short_name ? event.meta.division.short_name : '全体';
        groups[name] = groups[name] || [];
        groups[name].push(event);
      });
      cell['eventGroups'] = Object.entries(groups);
      */
    });
  }
  getCountUserEvent(eventid, date) {
    let dtstr = StringUtil.Object2Str(StringUtil.date2Object(date));
    let id = '' + eventid;
    if (id in this.countUserEvent) {
      if (dtstr in this.countUserEvent[id]) {
        return this.countUserEvent[eventid][dtstr];
      }
    }
    return 0;
  }
  getCalendar(viewDate: Date) {
    this.allEvents = [];
    this.calendar.getEeventCal(0,
      viewDate.getFullYear(),
      viewDate.getMonth() + 1,
      viewDate.getDate(),
      this.auth.getUserCode()
    ).subscribe((data: any[]) => {
      data.forEach(event => {
        let ev = this.json2CalEvent(event);
        this.viewEvents.push(ev);
        this.allEvents.push(ev);
      });
      this.countUserEvent = {};
      this.allEvents.forEach((event) => {
        let usercal = event.meta.user_calendar;
        usercal.forEach((uc) => {
          let dt = new Date(uc.start);
          let dtstr = StringUtil.Object2Str(StringUtil.date2Object(dt));
          let id = '' + event.id;
          if (id in this.countUserEvent) {
            if (dtstr in this.countUserEvent[id]) {
              this.countUserEvent[event.id][dtstr]++;
            } else {
              this.countUserEvent[event.id][dtstr] = 1;
            }
          } else {
            this.countUserEvent[event.id] = {};
            this.countUserEvent[event.id][dtstr] = 1;
          }
        });
      });
      this.filterEvent();
      this.refresh.next();
    });
  }

  onDivisionChange(division: string) {
    this.selectedDivision = parseInt(division, 10);
    this.filterEvent();
  }

  dayClicked(date: Date) {
    this.eventview = {
      id: null,
      start: StringUtil.date2Object(date),
      end: StringUtil.date2Object(date),
      title: '',
      //customer_code: event.meta.customer.customer_code,
      //child: event.meta.child,
      meta: {
        contents: '',
        place: '',
        division: {
          division_code: ''
        }
      }
    };
    this.viewEventInfo();
  }
  hourSegmentClicked(date: Date) {
  }

  eventClicked({ event }: { event: CalendarEvent }) {
    if (event.meta.type == 'event') {
      this.eventview = this.calEvent2ViewInfo(event);
      this.viewEventInfo();
    } else {
      this.userCalview = this.calUserEvent2ViewInfo(event);
      this.viewUserEventInfo();
    }
  }

  viewEventInfo() {
    this.modalReference = this.modal.open(this.eventAdd, { centered: true });
    this.modalReference.result.then((result) => { });
  }
  viewUserEventInfo() {
    this.modalReference = this.modal.open(this.userCal, { centered: true });
    this.modalReference.result.then((result) => { });
  }

  //
  viewInfo2CalEvent(info: any) {
    let startDate = StringUtil.Object2Str(info.start, '00:00');
    let endDate = StringUtil.Object2Str(info.end, '23:59');
    var event = {
      id: info.id ? info.id : null,
      title: info.title,
      start: startDate,
      end: endDate,
      allDay: true,
      meta: Object.assign({}, info.meta)
    }
    return event;
  }
  userViewInfo2CalEvent(info: any) {
    let startDate = StringUtil.Object2Str(info.start, (('00' + info.startTime_hour).slice(-2)) + ":" + (('00' + info.startTime_minute).slice(-2)));
    let endDate = StringUtil.Object2Str(info.start, (('00' + info.endTime_hour).slice(-2)) + ":" + (('00' + info.endTime_minute).slice(-2)));
    var event = {
      id: info.id ? info.id : null,
      title: info.title,
      start: startDate,
      end: endDate,
      allDay: false,
      meta: Object.assign({}, info.meta)
    }
    if (event.meta.user.user_code) {
    } else {
      event.meta.user.user_code = this.logininfo.user_code;
    }
    if (event.meta.sales.user_code) {
    } else {
      event.meta.sales.user_code = this.logininfo.user_code;
    }
    return event;
  }
  calEvent2ViewInfo(event: any) {
    var info = {
      id: event.id ? event.id : null,
      start: StringUtil.date2Object(event.start),
      end: StringUtil.date2Object(event.end),
      title: event.title,
      allDay: true,
      meta: Object.assign({}, event.meta)
    }
    return info;
  }
  calUserEvent2ViewInfo(event: any) {
    let startDate = StringUtil.date2Object(event.start);
    let endDate = StringUtil.date2Object(event.end);
    let startTime = StringUtil.date2ObjectTime(event.start);
    let endTime = StringUtil.date2ObjectTime(event.end);
    var info = {
      id: event.id ? event.id : null,
      title: event.title,
      start: startDate,
      end: (!event.allDay && endDate) ? endDate : null,
      startTime_hour: startTime ? startTime.hours : null,
      startTime_minute: startTime ? startTime.minutes : null,
      endTime_hour: (!event.allDay && endTime) ? endTime.hours : null,
      endTime_minute: (!event.allDay && endTime) ? endTime.minutes : null,
      allDay: event.allDay,
      meta: Object.assign({}, event.meta)
    }
    return info;
  }
  json2CalEvent(info: any) {
    var color;
    switch (info.meta.division.division_code) {
      case 1:
        color = division_colors.niconico;
        break;
      case 2:
        color = division_colors.hiraya;
        break;
      case 3:
        color = division_colors.tochi;
        break;
      default:
        color = division_colors.niconico;
    }
    var event = {
      id: info.id ? info.id : null,
      title: info.title,
      start: new Date(info.start),
      end: info.end ? new Date(info.end) : null,
      allDay: info.allDay,
      meta: Object.assign({}, info.meta),
      color: color
    }
    event.meta['type'] = 'event';
    this.divisionName2Code[info.meta.division.short_name] = info.meta.division.division_code;
    return event;
  }
  userjson2CalEvent(info: any) {
    var calColor;
    if (info.meta.user && info.meta.user.division) {
      switch (info.meta.user.division.division_code) {
        case 1:
          calColor = division_colors.niconico;
          break;
        case 2:
          calColor = division_colors.hiraya;
          break;
        case 3:
          calColor = division_colors.tochi;
          break;
        default:
          calColor = division_colors.niconico;
      }
    } else {
      calColor = colors.red;
    }
    let event = {
      id: info.id ? info.id : null,
      title: info.title,
      start: new Date(info.start),
      end: info.end ? new Date(info.end) : null,
      allDay: info.allDay,
      meta: Object.assign({}, info.meta),
      color: calColor
    }
    event.meta['type'] = 'user';
    return event;
  }
  filterEvent() {
    if (this.selectedDivision == 0) {
      this.viewEvents = this.allEvents;
    } else {
      this.viewEvents = this.allEvents.filter((val, index) => {
        if (val.meta.division.division_code == this.selectedDivision || val.meta.division.division_code == null) return true;
        return false;
      });
    }
    this.weekleyEvents = [];
    this.viewEvents.forEach((event) => {
      this.weekleyEvents.push(event);
      event.meta.user_calendar.forEach((ue) => {
        this.weekleyEvents.push(this.userjson2CalEvent(ue));
      })
    });
  }
  addCalendar() {
    this.modalReference.close();
    var event = this.viewInfo2CalEvent(this.eventview);
    this.calendar.setEventCal(event, this.logininfo.user_code
    ).subscribe((data) => {
      this.getCalendar(this.viewDate);
      this.ecalChange.emit(true);
    });

  }
  //顧客詳細へ
  customerDetail(id) {
    this.modalReference.close();
    this.router.navigate(['/detail/' + id]);
  }

  copyEvent() {
    this.modalReference.close();
    let event = this.userViewInfo2CalEvent(this.userCalview);
    let baseid = event.id;
    event.id = null;
    event.title = 'サポート';
    this.calendar.setUserCal(this.logininfo.user_code, event, this.logininfo.user_code, baseid
    ).subscribe((data) => {
      this.ecalChange.emit(true);
    });
  }
  delEvent() {
    this.modalReference.close();
    var event = this.viewInfo2CalEvent(this.eventview);
    //this.allEvents = [];
    this.calendar.delEventCal(event.id, this.logininfo.user_code
    ).subscribe((data) => {
      this.getCalendar(this.viewDate);
      this.ecalChange.emit(true);
    });
  }
  getName(fname, name, fkana, kana) {
    if (fname && name) {
      return fname + '　' + name;
    } else if (fkana && kana) {
      return fkana + '　' + kana;
    } else if (fname) {
      return fname;
    } else if (fkana) {
      return fkana;
    } else if (name) {
      return name;
    } else if (kana) {
      return kana;
    }
    return '';
  }
}
